export enum ErrorMessage {
  NO_OK_SUGGEST_RESPONSE = "Did not receive status code 200",
  EMPTY_SUGGESTIONS = "No suggestions to show",
  KEYWORDS_UNDEFINED = "Keywords are undefined!",
}

export const FALLBACK_SEARCH_URL = (term: string): string => {
  const trackingData = {
    "wk.san_SearchType": "search",
    "wk.san_ActiveSearch": "true",
    san_InitialSearch: "true",
    san_Interaction: "initial_search",
    san_TargetUrlResponseFallback: "true",
  };

  const ref = `#t${encodeURIComponent("=" + JSON.stringify(trackingData))}`;
  const encodedTerm = encodeURIComponent(term);
  return `https:/*🤫*/
};
